<script>
    import { push } from 'svelte-spa-router';
    import Page from 'components/Page';
    import NavBar from 'components/NavBar';
    import AnnouncementBanner from 'components/AnnouncementBanner';
</script>

<svelte:head>
    <title>Hire Purchase Customers - Standard Credit</title>
    <meta
        name="description"
        content="Your Standard Hire Purchase agreement remains valid. Continue payments easily online, in person, or through NLCB Bill Payment services. Get support for account or payment questions here."
    />
</svelte:head>

<NavBar
    activeLink="hpcustomers"
    on:register={() => push('/register')}
    on:hpcustomers={() => push('/hp-customers')}
    on:servicewarranties={() => push('/service-warranties')}
    on:login={() => push('/login')}
/>
<AnnouncementBanner />
<div class="root">
    <Page>
        <div slot="content">
            <!-- Hero Section -->
            <section class="hero">
                <div class="hero__container">
                    <h1 class="hero__title">Your Payments and Agreements Continue as Usual</h1>
                    <p class="hero__subtitle">Information for Hire-Purchase Customers</p>
                </div>
            </section>

            <!-- Main Content -->
            <section class="content-section">
                <div class="content-container">
                    <div class="card">
                        <h2 class="card__title">Seamless Transition</h2>
                        <p class="card__text">
                            If you have an existing Hire Purchase (HP) account, your agreement remains valid under our
                            new ownership. It's easy for you to continue to make payments through any of the following
                            options:
                        </p>
                    </div>

                    <!-- Trinidad & Tobago Section -->
                    <div class="country-section">
                        <h2 class="country-title">Trinidad & Tobago</h2>

                        <!-- Payment Options -->
                        <div class="payment-section">
                            <h3 class="section-title">Payment Options</h3>

                            <!-- In-Person Payment Hubs -->
                            <div class="payment-card">
                                <div class="payment-card__header">
                                    <i class="fa-solid fa-location-dot fa-2x"></i>
                                    <h3 class="payment-card__title">In-Person Payment Hubs</h3>
                                </div>
                                <p class="payment-card__text">
                                    Stay tuned to our socials for announcements on new, in-person payment locations.
                                </p>
                                <div class="locations-table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Area</th>
                                                <th>Payment Hub & Address</th>
                                                <th>Operating Hours</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Mt Hope</td>
                                                <td
                                                    >Current Standard Showroom: #1 Service Road, Mt Hope, Trinidad &
                                                    Tobago</td
                                                >
                                                <td>Mon–Fri: 9 am–5 pm<br />Sat: 9 am–3 pm</td>
                                            </tr>
                                            <tr>
                                                <td>Grand Bazaar</td>
                                                <td
                                                    >Shop A, Grand Bazaar Mall, Cor. Uriah Butler & Churchill Roosevelt
                                                    Hwy, Trinidad (Storefront previously occupied by Modern Touch)</td
                                                >
                                                <td>Mon–Sat: 10 am–6 pm</td>
                                            </tr>
                                            <tr>
                                                <td>Chaguanas</td>
                                                <td
                                                    >Current Standard Distributors Service Centre: ANSA McAL Centre
                                                    Endeavour Road, Chaguanas, Trinidad</td
                                                >
                                                <td>Mon–Fri: 9 am–3 pm</td>
                                            </tr>
                                            <tr>
                                                <td>Port of Spain</td>
                                                <td
                                                    >Previous Standard Showroom: ANSA House, Cor. Queen & Henry Sts,
                                                    Port-of-Spain, Trinidad</td
                                                >
                                                <td>Mon–Fri: 9 am–5 pm</td>
                                            </tr>
                                            <tr>
                                                <td>Coffee Street (San Fernando)</td>
                                                <td
                                                    >Current Standard Showroom: 167 Coffee Street, San Fernando,
                                                    Trinidad</td
                                                >
                                                <td>Mon–Fri: 9 am–5 pm<br />Sat: 9 am–3 pm</td>
                                            </tr>
                                            <tr>
                                                <td>Arima</td>
                                                <td
                                                    >Previous Standard Showroom: 4/4 A Prince Street, Old Blanchisseuse
                                                    Road, Arima, Trinidad</td
                                                >
                                                <td>Mon–Fri: 9 am–5 pm<br />Sat: 9 am–3 pm</td>
                                            </tr>
                                            <tr>
                                                <td>Tobago</td>
                                                <td
                                                    >The Tobago Marketing Company Ltd, Milford Road, Canaan, Tobago (on
                                                    the Carib Compound to the left of the current Standard Showroom)</td
                                                >
                                                <td>Mon–Fri: 9 am–5 pm<br />Sat: 9 am–3 pm</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- Bill Payment Services -->
                            <div class="payment-card">
                                <div class="payment-card__header">
                                    <i class="fa-solid fa-building-columns fa-2x"></i>
                                    <h3 class="payment-card__title">Bill Payment Services</h3>
                                </div>
                                <ul class="payment-list">
                                    <li>NLCB Bill Payment (Lotto booths nationwide)</li>
                                </ul>
                            </div>

                            <!-- Online Payment -->
                            <div class="payment-card">
                                <div class="payment-card__header">
                                    <i class="fa-solid fa-globe fa-2x"></i>
                                    <h3 class="payment-card__title">Online Payment Options</h3>
                                </div>
                                <ul class="payment-list">
                                    <li>
                                        Online banking transfer through your bank's app:<br />
                                        <strong>Beneficiary Name:</strong> STANDARD DISTRIBUTORS LIMITED<br />
                                        <strong>Beneficiary Account Number:</strong> 150 267 911 401<br />
                                        <strong>Beneficiary Bank:</strong> Republic Bank<br />
                                        <strong>Beneficiary Account Type:</strong> Chequing
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.fygaro.com/en/pb/2933de9e-e8f2-418f-bda3-65e585a3316d/"
                                            target="_blank"
                                            class="link">Credit card payment</a
                                        >
                                    </li>
                                    <li>
                                        Direct deposit or bank transfer: Republic Bank Ltd Account No. 150 267 911 401
                                    </li>
                                </ul>
                            </div>

                            <!-- Contact Section Trinidad -->
                            <div class="message-card">
                                <h3 class="message-card__title">Need Help?</h3>
                                <p class="message-card__text">
                                    If you have questions about your account, balance, or payment schedule, please
                                    contact
                                    <a href="mailto:ourcommitmenttoyou@ansamcal.com" class="message-card__link"
                                        >ourcommitmenttoyou@ansamcal.com
                                    </a>
                                    or call 868-299-0219 exts. 3813, 3819, 3852, 3863
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Barbados Section -->
                    <div class="country-section">
                        <h2 class="country-title">Barbados</h2>

                        <div class="payment-section">
                            <h3 class="section-title">Hire Purchase Payment Options</h3>

                            <!-- In-Person Payment -->
                            <div class="payment-card">
                                <div class="payment-card__header">
                                    <i class="fa-solid fa-location-dot fa-2x"></i>
                                    <h4 class="payment-card__title">In-person payment</h4>
                                </div>
                                <p class="payment-card__text">
                                    Current Standard Showroom: ANSA Motors Complex, Wildey, St Michael, Barbados<br />
                                    <strong>Operating Hours:</strong> Mon–Fri: 9 am–5 pm | Sat: 9 am–3 pm
                                </p>
                            </div>

                            <!-- Bill Payment Services -->
                            <div class="payment-card">
                                <div class="payment-card__header">
                                    <i class="fa-solid fa-building-columns fa-2x"></i>
                                    <h4 class="payment-card__title">Bill payment services</h4>
                                </div>
                                <p class="payment-card__text">
                                    <strong>Surepay (booths nationwide):</strong><br />
                                    <a
                                        href="https://surepaybills.com/payment-locations-barbados/"
                                        target="_blank"
                                        class="link">Payment Locations – Barbados – SurePay</a
                                    >
                                </p>
                            </div>

                            <!-- Online Payment -->
                            <div class="payment-card">
                                <div class="payment-card__header">
                                    <i class="fa-solid fa-globe fa-2x"></i>
                                    <h4 class="payment-card__title">Online</h4>
                                </div>
                                <p class="payment-card__text">
                                    <strong>Surepay Online:</strong><br />
                                    <a href="https://app.surepayonline.com/" target="_blank" class="link"
                                        >SurePay Online Payment Portal</a
                                    >
                                </p>
                            </div>

                            <!-- Bank Transfer -->
                            <div class="payment-card">
                                <div class="payment-card__header">
                                    <i class="fa-solid fa-building-columns fa-2x"></i>
                                    <h4 class="payment-card__title">Direct deposit or bank transfer</h4>
                                </div>
                                <div class="payment-card__text">
                                    <p><strong>STANDARD DISTRIBUTION & SALES (BARBADOS) LTD.</strong></p>
                                    <p><strong>BANK:</strong> Bank of Nova Scotia</p>
                                    <p><strong>ACCOUNT NO:</strong> 9014056 (Checking Account)</p>
                                    <p><strong>TRANSIT/BRANCH NO:</strong> 40055 (Broad Street)</p>
                                </div>
                            </div>

                            <!-- Contact Section Barbados -->
                            <div class="message-card">
                                <h3 class="message-card__title">Need Help?</h3>
                                <p class="message-card__text">
                                    If you have questions about your account, balance, or payment schedule, please
                                    contact
                                    <a href="mailto:info@standard.bb" class="message-card__link">info@standard.bb</a>
                                    or call <a href="tel:+12464307001" class="message-card__link">(246) 430-7001</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Page>
</div>

<style lang="scss">
    @use 'src/sass/base' as *;

    .root {
        min-height: 100vh;
        background: $color-white;
    }

    .hero {
        position: relative;
        margin-top: 65px;
        padding: em(60) em(25) em(50) em(25);
        text-align: center;
        background-image: url(/images/bg_2@2x.jpg);
        background-size: cover;
        background-position: center 35%;
        background-repeat: no-repeat;
        min-height: 300px;

        // Dark overlay
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            z-index: 1;
        }

        @include for-tablet-portrait-up {
            padding: em(80) em(40) em(60) em(40);
            min-height: 350px;
        }

        @include for-tablet-landscape-up {
            min-height: 380px;
        }

        &__container {
            position: relative;
            z-index: 2;
            max-width: 900px;
            margin: 0 auto;
            text-align: center;
        }

        &__title {
            font-size: em(32);
            font-weight: $fw-bold;
            background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(0, 188, 242, 1) 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: em(20);
            line-height: 1.2;

            @include for-tablet-portrait-up {
                font-size: em(48);
            }

            @include for-tablet-landscape-up {
                font-size: em(56);
            }
        }

        &__subtitle {
            font-size: em(18);
            font-weight: $fw-regular;
            color: rgba($color-white, 0.9);
            line-height: 1.5;
            text-align: center;

            @include for-tablet-portrait-up {
                font-size: em(22);
            }
        }
    }

    .content-section {
        padding: em(60) em(25);

        @include for-tablet-portrait-up {
            padding: em(80) em(40);
        }
    }

    .content-container {
        max-width: 1200px;
        margin: 0 auto;
    }

    .card {
        background: $color-white;
        border-radius: em(12);
        padding: em(40) em(30);
        margin-bottom: em(50);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        @include for-tablet-portrait-up {
            padding: em(50) em(40);
        }

        &__title {
            font-size: em(28);
            font-weight: $fw-bold;
            color: $color-primary;
            margin-bottom: em(20);

            @include for-tablet-portrait-up {
                font-size: em(32);
            }
        }

        &__text {
            font-size: em(18);
            font-weight: $fw-regular;
            color: $color-gray-text;
            line-height: 1.6;

            @include for-tablet-portrait-up {
                font-size: em(20);
            }
        }
    }

    .country-section {
        margin-bottom: em(60);
        padding-bottom: em(50);
        border-bottom: 2px solid $color-secondary;

        &:last-child {
            border-bottom: none;
        }
    }

    .country-title {
        font-size: em(36);
        font-weight: $fw-bold;
        color: $color-primary;
        margin-bottom: em(40);
        text-align: center;

        @include for-tablet-portrait-up {
            font-size: em(42);
        }
    }

    .payment-section {
        margin-bottom: em(50);
    }

    .section-title {
        font-size: em(28);
        font-weight: $fw-bold;
        color: $color-primary;
        margin-bottom: em(30);
        text-align: center;

        @include for-tablet-portrait-up {
            font-size: em(32);
        }
    }

    .payment-card {
        background: $color-white;
        border-radius: em(12);
        padding: em(30) em(25);
        margin-bottom: em(30);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        @include for-tablet-portrait-up {
            padding: em(40) em(35);
        }

        &__header {
            display: flex;
            align-items: center;
            gap: em(20);
            margin-bottom: em(20);
            color: $color-primary;
        }

        &__title {
            font-size: em(24);
            font-weight: $fw-bold;
            color: $color-black;
            margin: 0;

            @include for-tablet-portrait-up {
                font-size: em(28);
            }
        }

        &__text {
            font-size: em(16);
            color: $color-gray-text;
            line-height: 1.6;
            margin-bottom: em(20);

            @include for-tablet-portrait-up {
                font-size: em(18);
            }
        }
    }

    .payment-list {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            font-size: em(16);
            color: $color-gray-text;
            padding: em(12) 0;
            border-bottom: 1px solid lighten($color-gray, 5%);
            line-height: 1.6;

            &:last-child {
                border-bottom: none;
            }

            @include for-tablet-portrait-up {
                font-size: em(18);
            }
        }
    }

    .locations-table {
        overflow-x: auto;
        margin-top: em(20);

        table {
            width: 100%;
            border-collapse: collapse;
            font-size: em(14);

            @include for-tablet-portrait-up {
                font-size: em(16);
            }

            thead {
                background: $color-primary;
                color: $color-white;

                th {
                    padding: em(15) em(10);
                    text-align: left;
                    font-weight: $fw-bold;
                }
            }

            tbody {
                tr {
                    border-bottom: 1px solid lighten($color-gray, 5%);

                    &:hover {
                        background: lighten($color-secondary, 5%);
                    }

                    td {
                        padding: em(15) em(10);
                        color: $color-gray-text;
                        line-height: 1.5;
                    }
                }
            }
        }
    }

    .link {
        color: $color-primary;
        text-decoration: underline;
        transition: color 0.3s ease;

        &:hover {
            color: darken($color-primary, 10%);
        }
    }

    .message-card {
        background: linear-gradient(135deg, lighten($color-primary, 45%) 0%, lighten($color-primary, 40%) 100%);
        border-left: 4px solid $color-primary;
        border-radius: em(8);
        padding: em(30) em(25);

        @include for-tablet-portrait-up {
            padding: em(35) em(40);
        }

        &__title {
            font-size: em(22);
            font-weight: $fw-bold;
            color: $color-primary;
            margin-bottom: em(15);

            @include for-tablet-portrait-up {
                font-size: em(24);
            }
        }

        &__text {
            font-size: em(16);
            font-weight: $fw-regular;
            color: darken($color-primary, 20%);
            line-height: 1.6;
            margin: 0;

            @include for-tablet-portrait-up {
                font-size: em(18);
            }
        }

        &__link {
            color: $color-primary;
            font-weight: $fw-medium;
            text-decoration: underline;
            transition: color 0.3s ease;

            &:hover {
                color: darken($color-primary, 10%);
            }
        }
    }
</style>
